import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { STORAGE_KEYS } from 'constants/enums';
import useLocalStorage from 'hooks/useLocalStorage';
import { isNormalUserSelector } from 'selectors/user';
import { useAppSelector } from 'storeHooks';

export const useShowAvailableBalance = () => {
  const [showAmount] = useLocalStorage(STORAGE_KEYS.SHOW_BALANCE, true);
  const isNormalUser = useAppSelector(isNormalUserSelector);
  return !IS_INDIAN_EXCHANGE || !!showAmount || isNormalUser !== false;
};
